export const MODAL_NAME = 'orders.print-packing-slips'
